
import { createSlice } from '@reduxjs/toolkit';
import BaseApiState, { createBaseAPi } from "@/api/BaseApiState"
import { createPaymentOrder, verifyOnboardingPayment ,rescheduleBooking,createManualBooking,createDirectBooking,cancelManualBooking,verifyDirectBookingLinkSubscriptionPayment,createPaymentOrderForDirectBookingLinkSubscription,getVendorDirectBookingLinkVenuesSubscription,getSubscriptionPlanDetails,createRecommendation,verifyRecommendationSubscriptionPayment} from '../thunkMidddleware/paymentMiddleware';


interface paymentState {
    rescheduleBookingResponse:createBaseAPi,
    createPaymentOrderResponse: createBaseAPi,
    verifyOnboardingPaymentResponse: createBaseAPi,
    createPaymentOrderForDirectBookingLinkSubscriptionResponse:createBaseAPi,
    verifyDirectBookingLinkSubscriptionPaymentResponse:createBaseAPi,
    getVendorDirectBookingLinkVenuesSubscriptionResponse:createBaseAPi,
    getSubscriptionPlanDetailsResponse:createBaseAPi,
    createRecommendationResponse:createBaseAPi,
    verifyRecommendationSubscriptionPaymentResponse:createBaseAPi,
    createManualBookingResponse:createBaseAPi,
    createDirectBookingResponse:createBaseAPi,
    cancelManualBookingResponse:createBaseAPi


}

const initialState: paymentState = {
        rescheduleBookingResponse:BaseApiState,
cancelManualBookingResponse:BaseApiState,
    createManualBookingResponse:BaseApiState,
    createDirectBookingResponse:BaseApiState,
    verifyRecommendationSubscriptionPaymentResponse:BaseApiState,
    createRecommendationResponse:BaseApiState,
    getSubscriptionPlanDetailsResponse:BaseApiState,
    createPaymentOrderResponse: BaseApiState,
    verifyOnboardingPaymentResponse: BaseApiState,
    createPaymentOrderForDirectBookingLinkSubscriptionResponse:BaseApiState,
    verifyDirectBookingLinkSubscriptionPaymentResponse:BaseApiState,
    getVendorDirectBookingLinkVenuesSubscriptionResponse:BaseApiState

};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(createPaymentOrder.pending, (state) => {
                state.createPaymentOrderResponse.isLoading = true;
                state.createPaymentOrderResponse.error = null;
                state.createPaymentOrderResponse.success = false;
                state.createPaymentOrderResponse.message = null;

            })
            .addCase(createPaymentOrder.fulfilled, (state, action) => {
                let { payload, message } = action.payload
                state.createPaymentOrderResponse.isLoading = false;
                state.createPaymentOrderResponse.payload = payload;
                state.createPaymentOrderResponse.message = message;
                state.createPaymentOrderResponse.payload = payload;

            })
            .addCase(createPaymentOrder.rejected, (state, action) => {
                state.createPaymentOrderResponse.isLoading = false;
                // state.error = action?.error as string;
                state.createPaymentOrderResponse.success = false

            });

        // --------------------------------------------------------------------------------
        builder
        .addCase(createRecommendation.pending, (state) => {
            state.createRecommendationResponse.isLoading = true;
            state.createRecommendationResponse.error = null;
            state.createRecommendationResponse.success = false;
            state.createRecommendationResponse.message = null;

        })
        .addCase(createRecommendation.fulfilled, (state, action) => {
            let { payload, message } = action.payload
            state.createRecommendationResponse.isLoading = false;
            state.createRecommendationResponse.message = message;
            state.createRecommendationResponse.payload = payload;

        })
        .addCase(createRecommendation.rejected, (state, action) => {
            state.createRecommendationResponse.isLoading = false;
            // state.error = action?.error as string;
            state.createRecommendationResponse.success = false

        });

          // --------------------------------------------------------------------------------

          builder
          .addCase(verifyRecommendationSubscriptionPayment.pending, (state) => {
              state.verifyRecommendationSubscriptionPaymentResponse.isLoading = true;
              state.verifyRecommendationSubscriptionPaymentResponse.error = null;
              state.verifyRecommendationSubscriptionPaymentResponse.success = false;
              state.verifyRecommendationSubscriptionPaymentResponse.message = null;

          })
          .addCase(verifyRecommendationSubscriptionPayment.fulfilled, (state, action) => {
              let { payload, message } = action.payload
              state.verifyRecommendationSubscriptionPaymentResponse.isLoading = false;
              state.verifyRecommendationSubscriptionPaymentResponse.payload = payload;
              state.verifyRecommendationSubscriptionPaymentResponse.message = message;

          })
          .addCase(verifyRecommendationSubscriptionPayment.rejected, (state, action) => {
              state.verifyRecommendationSubscriptionPaymentResponse.isLoading = false;
              // state.error = action?.error as string;
              state.verifyRecommendationSubscriptionPaymentResponse.success = false

          });

      // --------------------------------------------------------------------------------


    // --------------------------------------------------------------------------------

        builder
            .addCase(verifyOnboardingPayment.pending, (state) => {
                state.verifyOnboardingPaymentResponse.isLoading = true;
                state.verifyOnboardingPaymentResponse.error = null;
                state.verifyOnboardingPaymentResponse.success = false;
                state.verifyOnboardingPaymentResponse.message = null;

            })
            .addCase(verifyOnboardingPayment.fulfilled, (state, action) => {
                let { payload, message } = action.payload
                state.verifyOnboardingPaymentResponse.isLoading = false;
                state.verifyOnboardingPaymentResponse.payload = payload;
                state.verifyOnboardingPaymentResponse.message = message;
                state.verifyOnboardingPaymentResponse.payload = payload;

            })
            .addCase(verifyOnboardingPayment.rejected, (state, action) => {
                state.verifyOnboardingPaymentResponse.isLoading = false;
                // state.error = action?.error as string;
                state.verifyOnboardingPaymentResponse.success = false

            });

        // --------------------------------------------------------------------------------



        builder
        .addCase(createPaymentOrderForDirectBookingLinkSubscription.pending, (state) => {
            state.createPaymentOrderResponse.isLoading = true;
            state.createPaymentOrderResponse.error = null;
            state.createPaymentOrderResponse.success = false;
            state.createPaymentOrderResponse.message = null;

        })
        .addCase(createPaymentOrderForDirectBookingLinkSubscription.fulfilled, (state, action) => {
            let { payload, message } = action.payload
            state.createPaymentOrderForDirectBookingLinkSubscriptionResponse.isLoading = false;
            state.createPaymentOrderForDirectBookingLinkSubscriptionResponse.payload = payload;
            state.createPaymentOrderForDirectBookingLinkSubscriptionResponse.message = message;
            state.createPaymentOrderForDirectBookingLinkSubscriptionResponse.payload = payload;

        })
        .addCase(createPaymentOrderForDirectBookingLinkSubscription.rejected, (state, action) => {
            state.createPaymentOrderForDirectBookingLinkSubscriptionResponse.isLoading = false;
            // state.error = action?.error as string;
            state.createPaymentOrderForDirectBookingLinkSubscriptionResponse.success = false

        });

    // --------------------------------------------------------------------------------

    builder
        .addCase(verifyDirectBookingLinkSubscriptionPayment.pending, (state) => {
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.isLoading = true;
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.error = null;
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.success = false;
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.message = null;

        })
        .addCase(verifyDirectBookingLinkSubscriptionPayment.fulfilled, (state, action) => {
            let { payload, message } = action.payload
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.isLoading = false;
            state.getVendorDirectBookingLinkVenuesSubscriptionResponse.success = true;
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.message = message;
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.payload = payload;

        })
        .addCase(verifyDirectBookingLinkSubscriptionPayment.rejected, (state, action) => {
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.isLoading = false;
            // state.error = action?.error as string;
            state.verifyDirectBookingLinkSubscriptionPaymentResponse.success = false

        });

    // --------------------------------------------------------------------------------

     // --------------------------------------------------------------------------------

     builder
     .addCase(getSubscriptionPlanDetails.pending, (state) => {
         state.getSubscriptionPlanDetailsResponse.isLoading = true;
         state.getSubscriptionPlanDetailsResponse.error = null;
         state.getSubscriptionPlanDetailsResponse.success = false;
         state.getSubscriptionPlanDetailsResponse.message = null;

     })
     .addCase(getSubscriptionPlanDetails.fulfilled, (state, action) => {
         let { payload, message } = action.payload
         state.getSubscriptionPlanDetailsResponse.isLoading = false;
         state.getSubscriptionPlanDetailsResponse.success = true;
         state.getSubscriptionPlanDetailsResponse.message = message;
         state.getSubscriptionPlanDetailsResponse.payload = payload;

     })
     .addCase(getSubscriptionPlanDetails.rejected, (state, action) => {
         state.getSubscriptionPlanDetailsResponse.isLoading = false;
         // state.error = action?.error as string;
         state.getSubscriptionPlanDetailsResponse.success = false

     });

 // --------------------------------------------------------------------------------


   // --------------------------------------------------------------------------------

   builder
   .addCase(getVendorDirectBookingLinkVenuesSubscription.pending, (state) => {
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.isLoading = true;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.error = null;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.success = false;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.message = null;

   })
   .addCase(getVendorDirectBookingLinkVenuesSubscription.fulfilled, (state, action) => {
       let { payload, message } = action.payload
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.isLoading = false;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.success = true;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.message = message;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.payload = payload;

   })
   .addCase(getVendorDirectBookingLinkVenuesSubscription.rejected, (state, action) => {
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.isLoading = false;
       // state.error = action?.error as string;
       state.getVendorDirectBookingLinkVenuesSubscriptionResponse.success = false

   });



   // --------------------------------------------------------------------------------

   builder
   .addCase(createManualBooking.pending, (state) => {
       state.createManualBookingResponse.isLoading = true;
       state.createManualBookingResponse.error = null;
       state.createManualBookingResponse.success = false;
       state.createManualBookingResponse.message = null;

   })
   .addCase(createManualBooking.fulfilled, (state, action) => {
       let { payload, message } = action.payload
       state.createManualBookingResponse.isLoading = false;
       state.createManualBookingResponse.success = true;
       state.createManualBookingResponse.message = message;
       state.createManualBookingResponse.payload = payload;

   })
   .addCase(createManualBooking.rejected, (state, action) => {
       state.createManualBookingResponse.isLoading = false;
       // state.error = action?.error as string;
       state.createManualBookingResponse.success = false

   });

    // --------------------------------------------------------------------------------

   builder
   .addCase(createDirectBooking.pending, (state) => {
       state.createDirectBookingResponse.isLoading = true;
       state.createDirectBookingResponse.error = null;
       state.createDirectBookingResponse.success = false;
       state.createDirectBookingResponse.message = null;

   })
   .addCase(createDirectBooking.fulfilled, (state, action) => {
       let { payload, message } = action.payload
       state.createDirectBookingResponse.isLoading = false;
       state.createDirectBookingResponse.success = true;
       state.createDirectBookingResponse.message = message;
       state.createDirectBookingResponse.payload = payload;

   })
   .addCase(createDirectBooking.rejected, (state) => {
       state.createDirectBookingResponse.isLoading = false;
       state.createDirectBookingResponse.success = false

   });

    // --------------------------------------------------------------------------------

   builder
   .addCase(cancelManualBooking.pending, (state) => {
       state.cancelManualBookingResponse.isLoading = true;
       state.cancelManualBookingResponse.error = null;
       state.cancelManualBookingResponse.success = false;
       state.cancelManualBookingResponse.message = null;

   })
   .addCase(cancelManualBooking.fulfilled, (state, action) => {
       let { payload, message } = action.payload
       state.cancelManualBookingResponse.isLoading = false;
       state.cancelManualBookingResponse.success = true;
       state.cancelManualBookingResponse.message = message;
       state.cancelManualBookingResponse.payload = payload;

   })
   .addCase(cancelManualBooking.rejected, (state, action) => {
       state.cancelManualBookingResponse.isLoading = false;
       // state.error = action?.error as string;
       state.cancelManualBookingResponse.success = false

   });

   //--------------------------------------------------------------------------------------

        builder
        .addCase(rescheduleBooking.pending, (state) => {
            state.rescheduleBookingResponse.isLoading = true;
            state.rescheduleBookingResponse.error = null;
        })
        .addCase(rescheduleBooking.fulfilled, (state, action) => {
            state.rescheduleBookingResponse.isLoading = false;
            state.rescheduleBookingResponse.success = action.payload?.success;
            state.rescheduleBookingResponse.payload = action.payload?.payload;
        })
        .addCase(rescheduleBooking.rejected, (state, action) => {
            state.rescheduleBookingResponse.isLoading = false;
            state.rescheduleBookingResponse.error = action.error as string;
            state.rescheduleBookingResponse.payload = null
        });
        
// --------------------------------------------------------------------------------

        // builder
        //   .addCase(logout.fulfilled, (state) => {
        //     state.user = null;
        //     state.token = null;
        //     state.isAuthenticated = false;
        //   })
        //   .addCase(verifyOtp.pending, (state) => {
        //     state.isLoading = true;
        //     state.error = null;
        //   });
        // builder
        //   .addCase(verifyOtp.fulfilled, (state, action) => {
        //     state.isLoading = false;
        //     state.isAuthenticated = true;
        //     state.user = action.payload.user;
        //     state.token = action.payload.token;
        //   })
        //   .addCase(verifyOtp.rejected, (state, action) => {
        //     state.isLoading = false;
        //     state.error = action.payload as string;
        //   });
    },
});

export const {

} = paymentSlice.actions;
export default paymentSlice.reducer;
